import React from 'react';
import { Container, Card, Table } from 'react-bootstrap';

const PrivacyPolicy = () => {
  return (
    <Container className="py-5">
      <h1 className="text-center mb-4 fw-bold">Politique de confidentialité</h1>
      <p className="text-center text-muted mb-5">Mise à jour le 25 février 2025</p>

      {/* Section 1 - Généralités */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">1. Généralités</h2>
          <p>
            GUIRETTE SAS, éditeur de la solution <strong>SaTeCO+</strong>, attache une importance primordiale à la protection de vos données à caractère personnel (ci-après « Données »).
          </p>
          <p>
            Vos Données sont traitées de manière sécurisée en conformité avec le RGPD (UE 2016/679) et la loi française n° 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés (LIL).
          </p>
          <p>
            Ce document présente les traitements que GUIRETTE réalise sur vos Données dans le cadre de l'utilisation de SaTeCO+ et du site web guirette.net.
          </p>
        </Card.Body>
      </Card>

      {/* Section 2 - Responsable du traitement */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">2. Responsable du traitement</h2>
          <p><strong>GUIRETTE SAS</strong></p>
          <ul>
            <li>RCS Marseille 123 456 789</li>
            <li>Adresse : 13013 MARSEILLE, FRANCE</li>
            <li>Email : hello@guirette.net</li>
          </ul>
          
          <h3 className="h5 mt-4 mb-3 fw-bold">Délégué à la Protection des Données :</h3>
          <p>
            Email : <a href="mailto:dpo@guirette.net">dpo@guirette.net</a><br />
            Courrier : À l'attention du DPO, 34 Boulevard NEUF, 13013 MARSEILLE
          </p>
          <p className="mt-3">
            Nous nous engageons à répondre à vos demandes dans un délai maximum de 30 jours après vérification de votre identité.
          </p>
        </Card.Body>
      </Card>

      {/* Section 3 - Finalités */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">3. Finalités du traitement</h2>
          <Table responsive bordered className="mb-4">
            <thead className="table-light">
              <tr>
                <th>Finalité</th>
                <th>Base légale</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Fournir les services SaTeCO+ (analyse des sols, surveillance des cultures)</td>
                <td>Exécution du contrat</td>
              </tr>
              <tr>
                <td>Répondre aux demandes de renseignements</td>
                <td>Consentement (prospects) / Exécution du contrat (clients)</td>
              </tr>
              <tr>
                <td>Amélioration des services</td>
                <td>Intérêt légitime</td>
              </tr>
              <tr>
                <td>Communication marketing</td>
                <td>Consentement</td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* Section 4 - Données collectées */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">4. Données collectées</h2>
          
          <h3 className="h5 mt-4 mb-3">Données collectées directement :</h3>
          <ul>
            <li>Données agricoles : localisation des parcelles, analyses de sol</li>
            <li>Données personnelles : nom, prénom, email, téléphone</li>
            <li>Données professionnelles : société, fonction, adresse</li>
          </ul>
        </Card.Body>
      </Card>

      {/* Section 5 - Destinataires */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">5. Destinataires des données</h2>
          <ul>
            <li>Services internes de GUIRETTE SAS</li>
            <li>Notre hébergeur : LWS France</li>
            <li>Autorités publiques si obligation légale</li>
          </ul>
          <p className="mt-3">
            Vos données sont stockées exclusivement en France.
          </p>
        </Card.Body>
      </Card>

      {/* Section 6 - Durée de conservation */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">6. Durée de conservation</h2>
          <Table responsive bordered>
            <thead className="table-light">
              <tr>
                <th>Type de données</th>
                <th>Durée</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Données clients</td>
                <td>3 ans après fin de contrat</td>
              </tr>
              <tr>
                <td>Données prospects</td>
                <td>2 ans après dernier contact</td>
              </tr>
              <tr>
                <td>Données techniques</td>
                <td>12 mois</td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* Section 7 - Sécurité */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">7. Sécurité des données</h2>
          <p>Mesures techniques et organisationnelles mises en œuvre :</p>
          <ul>
            <li>Chiffrement des données sensibles</li>
            <li>Sauvegardes régulières</li>
            <li>Protection des accès</li>
            <li>Audits de sécurité</li>
          </ul>
        </Card.Body>
      </Card>

      {/* Section 8 - Vos droits */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">8. Vos droits</h2>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul>
            <li>Droit d'accès et de rectification</li>
            <li>Droit à l'effacement</li>
            <li>Droit à la portabilité</li>
            <li>Droit d'opposition</li>
          </ul>
          <p className="mt-3">
            Pour exercer vos droits : <a href="mailto:dpo@guirette.net">dpo@guirette.net</a>
          </p>
        </Card.Body>
      </Card>

      {/* Section 9 - Cookies */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">9. Cookies</h2>
          <p>
            Notre site utilise des cookies pour son bon fonctionnement et l'analyse d'audience.
          </p>
          <p>
            Vous pouvez les gérer via les paramètres de votre navigateur.
          </p>
        </Card.Body>
      </Card>

      {/* Section 10 - Modifications */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">10. Modifications</h2>
          <p>
            Nous pouvons mettre à jour cette politique pour nous conformer aux évolutions légales.
          </p>
          <p>
            Les modifications seront publiées sur notre site avec indication de la date de mise à jour.
          </p>
        </Card.Body>
      </Card>

      {/* Footer */}
      <Card className="border-0 bg-light">
        <Card.Body className="text-center">
          <p className="mb-0">
            <strong>GUIRETTE SAS</strong> - Solution SaTeCO+ pour une agriculture de précision
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PrivacyPolicy;